import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const clientCode: string;

export interface CatalogExportProgressChannelData {
    message: string;
    progress: number;
    state: string;
}

class CatalogExportProgressUpdate {
    catalogExportProgressUpdateChannel: any;

    constructor() {
        this.catalogExportProgressUpdateChannel = App.cable.subscriptions.create(
            {
              channel: "Catalog::ExportProgressChannel",
              client_code: clientCode
            },
            {
              connected() {
                  console.log("Connected to Catalog Export Progress Update Channel");
               },
              disconnected() {
                console.log("Connected to Catalog Export Progress Update Channel");
              },
              received: (data: any) => this.updateProgress(data)
            }
          );
    }

    updateProgress(data: CatalogExportProgressChannelData) {
        $("#catalog_export_status").css("display", "block");
        $("#catalog_export_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#progressLabel").text(`${data.progress}%`);

        if (data.state === "complete") {
            setTimeout(() => $("#catalog_export_status").css("display", "none"), 2000);
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
      const m = new CatalogExportProgressUpdate();
    });
  }
